<template>
  <div>
    <a-tabs v-model="activekey">
      <a-tab-pane key="1" tab="轮播图">
        <banner></banner>
      </a-tab-pane>
      <a-tab-pane key="2" tab="资源介绍" force-render>
        <tab></tab>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import banner from './banner.vue';
import tab from './tab.vue'
export default {
  components: {
    banner,
    tab,
  },
  data() {
    return {
      activekey: "1",
    };
  },
};
</script>